<template>
  <div>
    <slot v-if="loading" name="loading"/>
    <slot v-else/>
  </div>
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    loading: { type: Boolean, default: false },
  }
}
</script>


// WEBPACK FOOTER //
// src/baseComponents/skeleton/Skeleton.vue